import React from "react";

const CustomRadio = (props)=>{
    return(
        <>
           <label className="radiobtn-container">{props.label}
            <input type="radio" 
            checked={props.checked} 
            name={props.name} 
            onChange={(e) => props.callback(e.target.value)} 
            value={props.val}></input>
            <span className="checkmark-radio"></span>
            </label>
        </>
    )
}

export default CustomRadio;